import { useState } from "react";
import CreateAdminRoleModal from "./CreateAdminRoleModal";

const CreateAdminRole = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {/* Create Admin Role Button */}
      <button
        onClick={openModal}
        className="px-6 py-3 bg-white text-black hover:bg-gray-100 border border-gray-300 rounded-lg text-sm font-medium transition-colors shadow-sm flex items-center gap-2"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
          />
        </svg>
        Create Admin Role
      </button>

      <CreateAdminRoleModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default CreateAdminRole;
